import styled from "styled-components";

export const Container = styled.div`
    padding: 124px 0;
    background-color: #fff;

    @media screen and (max-width: ${({theme}) => theme.breakpoints.laptop_big}) {
        padding: 106px 0;
    }
    
    @media screen and (max-width: ${({theme}) => theme.breakpoints.laptop}) {
        padding: 98px 0;
    } 
    
    @media screen and (max-width: ${({theme}) => theme.breakpoints.tablet}) {
        padding: 60px 0;
    }
`;



export const Title = styled.h2`
    font-size: 6rem;
    font-weight: 800;
    @media screen and (max-width: ${({theme}) => theme.breakpoints.laptop}) {
        font-size: 4.2rem;
        line-height: 1.1;
    }
    
    @media screen and (max-width: ${({theme}) =>
            theme.breakpoints.laptop_small}) {
    }
    
    @media screen and (max-width: ${({theme}) =>
            theme.breakpoints.tablet_big}) {
        font-size: 3.4rem;
    }
    
    @media screen and (max-width: ${({theme}) =>
            theme.breakpoints.phone_big}) and (orientation: portrait) {
        font-size: 3rem;
    }

    @media screen and (max-width: ${({theme}) =>
            theme.breakpoints.tablet}) and (orientation: landscape) {
        font-size: 2.8rem;
    }
    
    @media screen and (max-width: ${({theme}) =>
            theme.breakpoints.phone_big}) and (orientation: landscape) {
        font-size: 2.4rem;
    }
    
    @media screen and (max-width: ${({theme}) => theme.breakpoints.phone}) {
        text-align: center;
    }
`;

export const TextBoxesSection = styled.div`
    margin: 64px 0;
    display: flex;
    flex-wrap: wrap;

    @media screen and (max-width: ${({theme}) => theme.breakpoints.laptop}) {
    }

    @media screen and (max-width: ${({theme}) => theme.breakpoints.phone_big}) {
    }
`;

